import * as types from './project-member.types';
import * as constants from './project-member.constants';
import { generateClearResourceAction, generateStoreResourceAction } from '../generators/resource.actions';

export const storeProjectMember = generateStoreResourceAction<types.IProjectTeam>(constants.STORE_PROJECT_TEAM);
export const clearProjectMember = generateClearResourceAction(constants.CLEAR_PROJECT_MEMBER);
